import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import useAuth from '../../hooks/use-auth'
import SubmitButton from '../shared/submit-button'
import Logo from '../shared/logo'
import { TurnstileField } from '../shared/turnstile-container'
import { AUTH_STEPS } from '../../constants/auth-steps'
import { AuthModalBody } from '../auth-modal/auth-modal-body'
import { Iconify } from '@/Xmerald-UI'

export default function CloseOtherSessions() {
  const {
    onCloseAllSessionsClicked,
    sessionsData,
    submitting,
    closeSessionsStatus,
    turnstileToken
  } = useAuth()

  return (
    <AuthModalBody style={{ maxWidth: 500 }}>
      <Logo
        src='/images/Pickwin.png'
        alt='Pickwin logo'
      />
      <Title>Tienes sesiones abiertas en otros dispositivos</Title>
      <Text>Únicamente puedes tener una sesión activa en todo momento, para poder acceder en este dispositivo necesitas cerrar tus sesiones activas</Text>

      {sessionsData && sessionsData.sessions.map((item, index) => {
        return (
          <div key={index}>
            <div className='flex-row mb-1'>
              <div className='flex-col' style={{ fontSize: '0.9em', color: '#898989' }}>
                {moment(item.created).format('DD-MM-YY hh:mm a')}
              </div>
            </div>
            <div className='flex-row' style={{ display: 'flex', alignItems: 'center'}}>
              <Iconify
                icon='material-symbols:devices'
                style={{ fontSize: '3em', color: '#4c4c4c', marginRight: 10 }}
              />
              <div className='flex-col col-70' style={{ fontSize: '0.9em', color: '#c5c5c5' }}>{item.ua}</div>
              <div className='flex-col col-30' style={{ overflowWrap: 'break-word' }}>
                {item.ip}
              </div>
            </div>
          </div>
        )
      })}

      <div className='flex-col text-center'>
        <TurnstileField step={AUTH_STEPS.CLOSE_ANOTHER_SESSIONS} />

        <div className='flex-col mt-1'>
          {closeSessionsStatus
            ? <SubmitButton
              disabled={!turnstileToken}
              loading={submitting}
              onClick={onCloseAllSessionsClicked}
              style={{ width: '95%', marginTop: 10 }}
            >
              <span>Cerrar otras sesiones</span>
            </SubmitButton>
            : <h4 className='flex-container justify'>No se pudo realizar el cierre de sesiones. Cierra esta ventana e intenta nuevamente</h4>}
        </div>
      </div>

    </AuthModalBody>
  )
}

const Title = styled.div`
  color: #88ba44;
  font-size: 1.3em;
  text-align: center;
`

const Text = styled.p`
  color: #FFF;
  font-size: 1em;
  text-align: center;
`
